import React from 'react';

import BismillahSVG from '@/public/bismillah.svg';

const Bismillah = () => <BismillahSVG />;

export default Bismillah;
